// extracted by mini-css-extract-plugin
export var defaultWrapper = "_hj-3";
export var downloadButton = "_hj-4";
export var fileContainer = "_hj-9 _hj-7";
export var fileContainerBase = "_hj-7";
export var fileContainerFixedHeight = "_hj-8 _hj-7";
export var fileInfo = "_hj-5";
export var fileInfoWidthRestricted = "_hj-6";
export var fileType = "_hj-1";
export var fileTypeName = "_hj-2";
export var image = "_hj-0";
export var link = "_hj-b";
export var overflowEllipsis = "_hj-a";